<div class="p-3 pt-1 text-center 2xl:text-sm text-xs dark:text-white-dark ltr:sm:text-left rtl:sm:text-right">
    © {{ currYear }}. {{ appName }} All rights reserved.
</div>
